import React, { useEffect, useState } from "react";
import PlanetCard from "../PlanetCard/PlanetCard";
import { useDispatch } from "react-redux";
import { setCustomerLogo, signInUser } from "../../actions/authActions";
import { activateSupplier, validateSupplier } from "../../services/srmService";
import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  fetchCompanyOrBusinessUnitByRegistration,
  industriesService,
} from "../../services/orgService";
import { Cascader } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { PhoneInput } from "react-international-phone";
import MapsInput from "../common/MapsInput";
import {
  getUserEnabledStatus,
  logInService,
  logout,
  signUpService,
} from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./SupplierRegistration.scss";
import { toastMessage } from "../../helper";
import { checkUserAssociation } from "../../services/userService";

export default function SupplierRegistration(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  let [isEmailVerified, setIsEmailVerifeid] = useState(false);
  let [userId, setUserId] = useState(0);
  let [companyId, setCompanyId] = useState(null);
  let [phone, setPhone] = useState("");
  let [supplierId, setSupplierId] = useState("");
  let [useLogin, setUseLogin] = useState(false);
  const handleInputChange = (e: any, field: any) => {
    console.log(e, field);
    if (field === "phone") {
      let dialCode = e.split(" ")[0];
      formData["dialCode"] = dialCode;
      formData["phone"] = e.substring(dialCode.length + 1);
      setFormData({ ...formData });
      return;
    }
    // if(field=="address"){
    //   setAddress(e);
    // }
    if (field == "industry") {
      setIndustryData(e);
      formData["industry"] = industries
        .filter((item) => item.label == e[0])[0]
        .children.filter((item: any) => item.label == e[1])[0].id;
      setFormData({ ...formData });
      return;
    }
    if (
      e.target.name === "privacyPolicy" ||
      e.target.name === "servicePolicy"
    ) {
      formData[field] = e.target.checked;
      setFormData({ ...formData });
    } else {
      formData[field] = e.target.value;
      setFormData({ ...formData });
    }
  };
  const validateForm = () => {
    return (
      formData.servicePolicy &&
      formData.privacyPolicy &&
      formData.userDisplayName &&
      formData.registrationId &&
      formData.company &&
      (formData.password || isEmailVerified) &&
      formData.industry
    );
  };

  let [supplierAdminEmail, setSupplierAdminEmail] = useState("");

  const onSubmit = async (e: any) => {
    let data = { ...formData };
    data["supplierId"] = Number(supplierId);
    const companyRes = (
      await fetchCompanyOrBusinessUnitByRegistration(
        formData["registrationId"],
        false
      )
    ).data;
    const businessUnitRes = (
      await fetchCompanyOrBusinessUnitByRegistration(
        formData["registrationId"],
        true
      )
    ).data;
    if (isEmailVerified) {
      let isCompanyMatched = false;
      let isFacilityMatched = false;
      if (Object.keys(companyRes).length && companyRes.id) {
        setCompanyId(companyRes.id);
        try {
          const associationRes = await checkUserAssociation(
            userId,
            companyRes.id,
            null
          );
          if (associationRes.status == 200) {
            isCompanyMatched = true;
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        if (Object.keys(businessUnitRes).length && businessUnitRes.id) {
          isFacilityMatched = true;
          const associationRes = await checkUserAssociation(
            userId,
            companyRes.id,
            null
          );
          if (associationRes.status == 200) {
            isCompanyMatched = true;
          }
        }
      }
      if (!isCompanyMatched && !isFacilityMatched) {
        toastMessage(
          "A different registration ID has already been associated with this email address. Please verify the registration ID or contact support@planetwise.io for assistance.",
          "error"
        );
        return;
      } else {
        setUseLogin(true);
        setSupplierAdminEmail(companyRes.email);
      }
    } else {
      if (companyRes.id || businessUnitRes.id) {
        toastMessage(
          "It seems that another email address has been linked to the Registration ID. If someone from your company has already registered, please ask them to add you as an employee within the company to access the PlanetWise application. Otherwise, please contact support@planetwise.io for assistance.",
          "error"
        );
        return;
      }
      signUpService(data)
        .then((res) => {
          signInUser(
            formData.email,
            formData.password,
            "login",
            "Corporate"
          ).then((data) => {
            window.location.href =
              window.location.origin + "/partners/customers/list";
          });
        })
        .catch((err: any) => {
          toastMessage(err.response.data.message, "error");
        });
    }
  };

  let [formData, setFormData] = useState<any>({
    email: "",
    company: "",
    registrationId: "",
    industry: 0,
    userDisplayName: "",
    dialCode: "",
    phone: "",
    password: "",
    address: {
      addressLine: "",
      city: "",
      cityCode: "",
      state: "",
      stateCode: "",
      country: "",
      countryCode: "",
    },
    privacyPolicy: false,
    servicePolicy: false,
  });

  let [address, setAddress] = useState<any>({
    addressLine1: "",
    city: "",
    cityCode: "",
    state: "",
    stateCode: "",
    country: "",
    countryCode: "",
  });

  const [industries, setIndustries] = useState([] as any[]);
  const fetchIndustryData = async () => {
    const indusRes = await industriesService();
    industries.length = 0;
    indusRes.data.map((each: any) => {
      const childrenData: any = [];
      each.children.map((eachchildren: any) => {
        childrenData.push({
          value: eachchildren.name,
          label: eachchildren.name,
          id: eachchildren.id,
        });
      });
      const currData = {
        value: each.code,
        label: each.code,
        children: [...childrenData],
      };
      industries.push(currData);
    });
    setIndustries([...industries]);
  };

  let [viewPassword, setViewPassword] = useState(false);

  let [industryData, setIndustryData] = useState<any[]>([]);

  const loginAndUpdateSupplier = () => {
    signInUser(formData.email, formData.password, "login", "Corporate")
      .then(async (data) => {
        let update = {
          supplier: supplierId,
          companyId: companyId,
          adminEmail: supplierAdminEmail,
          address: formData.address,
          companyName: formData.company,
        };
        let res = await activateSupplier(update);
        if (res.status == 200) {
          window.location.href =
            window.location.origin + "/partners/customers/list";
        }
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  };
  useEffect(() => {
    if (localStorage.getItem("token")) {
      logout();
    }
    fetchIndustryData();
    const searchParams = new URLSearchParams(window.location.search);
    if (
      searchParams.get("supplierId") != null &&
      searchParams.get("otp") != null
    ) {
      setSupplierId(searchParams.get("supplierId") || "");
      validateSupplier(
        searchParams.get("supplierId"),
        searchParams.get("otp")
      ).then((res) => {
        if (res.data.message) {
          toastMessage(res.data.message, "error");
          navigate("/auth/login");
          return;
        }
        setTimeout(async () => {
          try {
            let userStatusData = await getUserEnabledStatus(res.data.email);
            if (!userStatusData.data.error_code) {
              if (userStatusData.data.status == "APPROVED") {
                setIsEmailVerifeid(true);
                setUserId(userStatusData.data.id);
              }
            }
          } catch (e) {
            console.log(e);
          }
          for (let i = 0; i < industries.length; i++) {
            for (let j = 0; j < industries[i].children.length; j++) {
              if (industries[i].children[j].id == res.data.industry) {
                setIndustryData([
                  industries[i].value,
                  industries[i].children[j].value,
                ]);
              }
            }
          }
        }, 300);
        formData.email = res.data.email;
        formData.company = res.data.name;
        formData.registrationId = res.data.registration_id;
        formData.industry = res.data.industry;
        formData.userDisplayName = res.data.contact_name;
        formData.phone = res.data.phone;
        formData.dialCode = res.data.dial_code;
        formData.address = res.data.address || {};
        setPhone(res.data.dial_code + " " + res.data.phone);
        setAddress({
          addressLine1: res.data.address.addressLine,
          city: res.data.address.city,
          cityCode: res.data.address.cityCode,
          state: res.data.address.state,
          stateCode: res.data.address.stateCode,
          country: res.data.address.country,
          countryCode: res.data.address.countryCode,
        });
        setFormData({ ...formData });
        dispatch(setCustomerLogo(res.data.customer_logo));
      });
    }
  }, []);
  return useLogin ? (
    <>
      <span className="pw-input-label">
        Current Password<span className="pw-mandatory-icon">*</span>
      </span>
      <OutlinedInput
        type={viewPassword ? "text" : "password"}
        onChange={(e) => handleInputChange(e, "password")}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onMouseDown={() => {
                setViewPassword(true);
              }}
              onClick={() => {
                setViewPassword(false);
              }}
              edge="end"
            >
              {viewPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />

      <Button
        variant="contained"
        sx={{ padding: "10px !important", color: "white" }}
        style={{ marginTop: "15px", fontWeight: "700", textTransform: "none" }}
        className={`pw-cursor-pointer ${
          formData.password.length >= 8
            ? "pw-primary-button"
            : "pw-neutral-background"
        }`}
        onClick={(e) => loginAndUpdateSupplier()}
        disabled={!(formData.password.length >= 8)}
      >
        Add
      </Button>
    </>
  ) : (
    <>
      <br />
      <span className="pw-input-label">
        Company Name<span className="pw-mandatory-icon">*</span>
      </span>
      <OutlinedInput
        value={formData.company}
        onChange={(e) => handleInputChange(e, "company")}
      />
      <span className="pw-input-label">
        Primary Contact<span className="pw-mandatory-icon">*</span>
      </span>
      <OutlinedInput
        value={formData.userDisplayName}
        onChange={(e) => handleInputChange(e, "userDisplayName")}
      />
      <span className="pw-input-label">
        Industry Type<span className="pw-mandatory-icon">*</span>
      </span>
      <Cascader
        suffixIcon={<CaretDownOutlined className="!pointer-events-none" />}
        className="pw-creation-select pw-facility-select pw-e2e-industrytype"
        placeholder="Select Industry Type"
        style={{ width: "29rem" }}
        options={industries}
        value={industryData}
        onChange={(e) => handleInputChange(e, "industry")}
      />
      <span className="pw-input-label">
        Email ID<span className="pw-mandatory-icon">*</span>
      </span>
      <OutlinedInput value={formData.email} type="email" disabled />
      <span className="pw-input-label">Phone No.</span>
      <PhoneInput
        value={phone}
        initialCountry="in"
        forceDialCode
        onChange={(phone) => handleInputChange(phone, "phone")}
      />
      <span className="pw-input-label">
        Registration ID<span className="pw-mandatory-icon">*</span>
      </span>
      <OutlinedInput
        value={formData.registrationId}
        onChange={(e) => handleInputChange(e, "registrationId")}
      />
      <span className="pw-input-label">
        Address<span className="pw-mandatory-icon">*</span>
      </span>
      <MapsInput
        defaultValue={address}
        onChange={(e: any) => handleInputChange(e, "address")}
      />
      {!isEmailVerified ? (
        <>
          <span className="pw-input-label">
            Password<span className="pw-mandatory-icon">*</span>
          </span>
          <OutlinedInput
            type={viewPassword ? "text" : "password"}
            onChange={(e) => handleInputChange(e, "password")}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onMouseDown={() => {
                    setViewPassword(true);
                  }}
                  onClick={() => {
                    setViewPassword(false);
                  }}
                  edge="end"
                >
                  {viewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </>
      ) : (
        ""
      )}
      <div className="flex flex-row pw-shift-left-10 mt-4">
        <Checkbox
          value={formData.privacyPolicy}
          name="privacyPolicy"
          onChange={(e) => handleInputChange(e, "privacyPolicy")}
        />
        <div className="text-sm">
          <span>{t("privacyPolicy")}</span>
          <a
            href="https://planetwise.io/privacy-policy"
            target="_blank"
            rel="noreferrer"
            className="pw-primary-color pw-text-underline font-semibold"
          >
            {t("privacyPolicyLink")}
          </a>
        </div>
      </div>
      <div className="flex flex-row pw-shift-left-10 mt-4">
        <Checkbox
          value={formData.servicePolicy}
          color="primary"
          name="servicePolicy"
          onChange={(e) => handleInputChange(e, "servicePolicy")}
        />
        <div className="text-sm">
          <span>{t("servicePolicy")}</span>
          <a
            href="https://planetwise.io/terms-conditions"
            target="_blank"
            rel="noreferrer"
            className="pw-primary-color pw-text-underline font-semibold"
          >
            {t("servicePolicyLink")}
          </a>
        </div>
      </div>
      <Button
        variant="contained"
        sx={{ padding: "10px !important", color: "white" }}
        style={{ marginTop: "15px", fontWeight: "700", textTransform: "none" }}
        className={`pw-cursor-pointer ${
          validateForm() ? "pw-primary-button" : "pw-neutral-background"
        }`}
        onClick={(e) => onSubmit(e)}
        disabled={!validateForm()}
      >
        Register
      </Button>
    </>
  );
}
